import { Routes } from '@angular/router';

import { authGuard, guestOnlyGuard, superAdminGuard } from './core/auth/auth.guard';
import { ShellComponent } from './shell/shell.component';

import { AvailablePage } from './pages/inbox/inbox.page';
import { MyCasesPage } from './pages/my-cases/my-cases.page';
import { PastOrdersPage } from './pages/past-orders/past-orders.page';
import { SignInPage } from './pages/auth/sign-in.page';
import { ForgotPasswordPage } from './pages/auth/forgot-password.page';
import { ConfirmPasswordResetPage } from './pages/auth/confirm-password-reset.page';
import { HandoffSummaryPage } from './pages/handoff-summary/handoff-summary.page';
import { SettingsPage } from './pages/settings/settings.page';
import { SearchPage } from './pages/search/search.page';
import { CreateProviderPage } from './pages/providers/create-provider.page';
import { ProvidersPage } from './pages/providers/providers.page';
import { ProviderProfilePage } from './pages/providers/provider-profile.page';
import { ServiceCategoriesPage } from './pages/service-categories/service-categories.page';
import { ServiceCategoryDetailPage } from './pages/service-categories/service-category-detail.page';
import { CreateServiceCategoryPage } from './pages/service-categories/create-service-category.page';
import { ConfirmedCompletedPage } from './pages/confirmed-completed/confirmed-completed.page';
import { CustomersPage } from './pages/customers/customers.page';

export const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: 'available', component: AvailablePage },
      { path: 'available/:handoffId', component: HandoffSummaryPage },
      { path: 'my-cases', component: MyCasesPage },
      { path: 'my-cases/:id', component: MyCasesPage },
      { path: 'conversations/:id', component: MyCasesPage },
      { path: 'past-orders', component: PastOrdersPage },
      { path: 'confirmed-completed', component: ConfirmedCompletedPage },
      { path: 'providers/new', component: CreateProviderPage, canActivate: [superAdminGuard] },
      { path: 'providers/:id/edit', component: CreateProviderPage, canActivate: [superAdminGuard] },
      { path: 'providers/:id', component: ProviderProfilePage },
      { path: 'providers', component: ProvidersPage },
      { path: 'service-categories/new', component: CreateServiceCategoryPage, canActivate: [superAdminGuard] },
      { path: 'service-categories/:id', component: ServiceCategoryDetailPage },
      { path: 'service-categories', component: ServiceCategoriesPage },
      { path: 'customers', component: CustomersPage },
      // Lazy: keeps chart.js out of the initial bundle — /stats is SUPERADMIN-only.
      {
        path: 'stats',
        loadComponent: () => import('./pages/stats/stats.page').then(m => m.StatsPage),
        canActivate: [superAdminGuard],
      },
      { path: 'search', component: SearchPage },
      { path: 'settings', component: SettingsPage },
      { path: 'inbox', redirectTo: 'available', pathMatch: 'full' },
      { path: '', redirectTo: 'available', pathMatch: 'full' },
    ],
  },
  {
    path: 'auth',
    children: [
      { path: 'sign-in', component: SignInPage, canActivate: [guestOnlyGuard] },
      { path: 'forgot-password', component: ForgotPasswordPage, canActivate: [guestOnlyGuard] },
      { path: 'confirm-password-reset', component: ConfirmPasswordResetPage },
      { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '' },
];
